import React, { useEffect } from 'react'

//
import cn from 'classnames'
import { ButtonNew, FAQ, LoadMore, SectionHeader } from '../../../storybook'
import { ALIGN, HEADING_TYPE } from '../../../storybook/SectionHeader'
import { getMicroCopy } from '../../../utils/microcopy'
import { getUrl } from '../../../utils/urls'
import { LocationContext, SiteDataContext } from '../../page-wrapper'
import { useMicroCopyData } from '@/src/context/MicroCopyContext'
import { THEME } from '@/src/utils/common'
import { useNavigationData } from '@/src/context/NavigationContext'

const BlockFaqTop = ({ data }) => {
  const location = React.useContext(LocationContext)
  const { lang } = React.useContext(SiteDataContext)
  const { navigationItems } = useNavigationData()
  const microCopyData = useMicroCopyData()
  const { slugPrefix } = location
  const limit = 10

  const questions = data.questions
    ? data.questions.map((question) => ({
        question: question.title,
        answer: question.description
      }))
    : []

  const [offsetToShow, setOffsetToShow] = React.useState(limit)

  useEffect(() => {
    setOffsetToShow(limit)
  }, [])

  return (
    <section
      className={cn('l-section', {
        'l-section--dark c-faq-top--dark': data.theme === THEME.dark
      })}
    >
      <div className="l-container:12/12 l-container--default-spacing">
        <div className="l-grid l-grid--default-spacing">
          <div className="c-faq-top__header l-grid__col:4/12 l-grid__col:12/12@to:viewport-9">
            <SectionHeader
              title={data?.title}
              text={data?.description}
              headingType={HEADING_TYPE.h3}
              align={ALIGN.left}
              inverted={data.theme === THEME.dark}
            >
              {data.action ? (
                <ButtonNew
                  variant={'green'}
                  url={getUrl({
                    navItem: data.action,
                    slugPrefix: slugPrefix,
                    navigationItems: navigationItems
                  })}
                >
                  {data.action.title}
                </ButtonNew>
              ) : null}
            </SectionHeader>
          </div>
          <div className="l-grid__col:8/12 l-grid__col:12/12@to:viewport-9">
            {questions.length > 0 ? (
              <FAQ
                inverted={data.theme === THEME.dark}
                faqs={questions.slice(0, offsetToShow)}
                classes={['l-section--no-padding-top', 'l-section--no-padding-bottom']}
                defaultSpacing={false}
                footerSlot={
                  offsetToShow < questions.length && (
                    <div className="l-section__footer">
                      <LoadMore
                        current={offsetToShow}
                        total={questions.length}
                        loadLabel={getMicroCopy({
                          key: `paginationLoadMore`,
                          data: microCopyData[lang]
                        })}
                        separationLabel={getMicroCopy({
                          key: `paginationOf`,
                          data: microCopyData[lang]
                        })}
                        handleLoadMore={() => setOffsetToShow(offsetToShow + limit)}
                      />
                    </div>
                  )
                }
              />
            ) : (
              <p>{getMicroCopy({ key: 'noFaqsMessage', data: microCopyData[lang] })}</p>
            )}
          </div>
        </div>
      </div>
    </section>
  )
}

export default BlockFaqTop
